import React from 'react'
import '../../fonts/fonts.css'
import SideBar from '../SideBar/index'
import Store from '../Store/index'
import { Bg, MainLayout, ContentLayout } from './styledComponents'

const StorePage = () => {
  return (
    <Bg>
      <SideBar />
      <MainLayout>
        <ContentLayout>
          <Store />
        </ContentLayout>
      </MainLayout>
    </Bg>
  )
}

export default StorePage
